import { Component, OnInit } from '@angular/core';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FileService} from '../shared/services/fileService/file.service';
import {VoucherService} from '../shared/services/voucher/voucher.service';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {DatePipe} from '@angular/common';
import {LocalStorageService} from '../shared/services/localStorageService/local-storage.service';
import {EmailService} from '../shared/services/emailService/email.service';
import {MatDialog} from '@angular/material';
import {FioService} from '../shared/services/databaseServices/fioService/fio.service';
import {FormBuilder, Validators} from '@angular/forms';
import {Voucher} from '../shared/classes/Voucher';

@Component({
  selector: 'app-voucher-detail',
  templateUrl: './voucher-detail.component.html',
  styleUrls: ['./voucher-detail.component.css']
})
export class VoucherDetailComponent implements OnInit {

  id;
  voucher: Voucher;
  voucherType = ['ABS', '%'];

  voucherForm = this.formBuilder.group({
    keyword: ['', [Validators.required]],
    value: ['', [Validators.required, Validators.pattern('^[0-9]*')]],
    type: ['', [Validators.required]],
    date: ['', [Validators.required]],
    time: [':', [Validators.required, Validators.pattern('[0-2][0-9]:[0-5][0-9]')]],
    pieces: ['0', [Validators.required, Validators.min(0)]],
  });

  isNew = false;
  plusButton = true;
  editButton = false;
  createTooltip = 'raceDetailPage.voucherTab.saveToolTip';
  deleteTooltip = 'raceDetailPage.voucherTab.deleteToolTip';
  addTooltip = 'raceDetailPage.voucherTab.addToolTip';

  constructor(private formsService: FormsService,
              private activatedRoute: ActivatedRoute,
              private fileService: FileService,
              private voucherService: VoucherService,
              private racesService: RacesService,
              private emailTableService: EmailTableService,
              private racerService: RacerService,
              private router: Router,
              private datePipe: DatePipe,
              private localStorageService: LocalStorageService,
              private emailService: EmailService,
              public dialog: MatDialog,
              private fioService: FioService,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.isNew = this.voucherService.editVoucherId === -1;
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    if(this.isNew) {
      this.voucher = new Voucher();
    } else {
      this.plusButton = false;
      this.editButton = true;
      this.voucher = this.voucherService.vouchers.find(i => i.id === this.voucherService.editVoucherId);
      this.loadForm();
    }
  }

  loadForm() {
    this.voucherForm.patchValue({
      keyword: this.voucher.keyword,
      value: this.voucher.value,
      type: this.voucher.type,
      date: this.createDate(this.voucher.date.toString().split(' ')[0]),
      time: this.voucher.date.toString().split(' ')[1],
      pieces: this.voucher.pieces
    });
  }

  createDate(date: string) {
    const d: string[] = date.split('.');
    const toTranslate = `${d[2]}/${d[1]}/${d[0]}`;
    console.dir(toTranslate);
    return new Date(toTranslate);
  }

  save(item) {
    this.voucher.keyword = this.voucherForm.getRawValue().keyword;
    this.voucher.pieces = this.voucherForm.getRawValue().pieces;
    this.voucher.type = this.voucherForm.getRawValue().type;
    this.voucher.value = this.voucherForm.getRawValue().value;
    const d = new Date(this.voucherForm.getRawValue().date);
    const c = `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
    const time = new Date(c + " " + this.voucherForm.getRawValue().time).getTime();
    console.log(time);
    this.voucher.date = time;

    this.voucherService.vouchers.forEach(v => {
      if (typeof v.date === 'string') {
        v.date = this.translateTime(v.date).getTime();
      }
    });

    const done: Voucher[] = [];
    for(let i = 0; i < this.voucherService.vouchers.length; i++) {
      if(i !== this.voucherService.editVoucherId){
        done.push(this.voucherService.vouchers[i]);
      } else {
        done.push(this.voucher);
      }
    }

    this.voucherService.vouchers = done;
    this.voucherService.update(this.voucherService.vouchers, this.id).then(() => {
      this.router.navigate(['/admin/races/voucher', this.id]);
    }).catch((err) => {
      console.log(err);
    });
  }

  translateTime(dt: string){
    const d = dt.split(' ');
    const d0 = d[0].split('.');
    const t = `${d0[2]}/${d0[1]}/${d0[0]} ${d[1]}`;
    return new Date(t);
  }

  add(item) {
    this.voucher.keyword = this.voucherForm.getRawValue().keyword;
    this.voucher.pieces = this.voucherForm.getRawValue().pieces;
    this.voucher.type = this.voucherForm.getRawValue().type;
    this.voucher.value = this.voucherForm.getRawValue().value;
    const d = new Date(this.voucherForm.getRawValue().date);
    const c = `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
    const time = new Date(c + " " + this.voucherForm.getRawValue().time).getTime();
    console.log(time);
    this.voucher.date = time;
    if (this.voucherService.vouchers.length > 0){
      this.voucherService.vouchers.forEach(v => {
        v.date = this.translateTime(v.date).getTime();
      });
      this.voucherService.vouchers.push(this.voucher);
      this.voucherService.update(this.voucherService.vouchers, this.id).then(() => {
        console.log('up');
        this.router.navigate(['/admin/races/voucher', this.id]);
      }).catch((err) => {
        console.log(err);
      })
    } else {
      this.voucherService.vouchers = [];
      this.voucherService.vouchers.push(this.voucher);
      this.voucherService.create(this.voucherService.vouchers, this.id).then(() => {
        this.router.navigate(['/admin/races/voucher', this.id]);
      }).catch((err) => {
        console.dir(err);
      });
    }
  }

  delete(item) {
    const done: Voucher[] = [];
    for(let i = 0; i < this.voucherService.vouchers.length; i++) {
      if(i !== this.voucherService.editVoucherId){
        done.push(this.voucherService.vouchers[i]);
      }
    }
    this.voucherService.vouchers = done;
    this.voucherService.update(this.voucherService.vouchers, this.id).then(() => {
      this.router.navigate(['/admin/races/voucher', this.id]);
    }).catch((err) => {
      console.dir(err);
    });
  }

}
